import { SynchronizedResult } from '@paragon/contract-library';
import { buildMiddleware, Middleware, UpdateResponse } from '@paragon/data-connections';
import { hasAssemblyPermission, shouldSynchronizeComponent } from '@paragon/login-tools';
import { enqueuePermanentError } from '@paragon/notification-tools';

import { store } from '../index';
import { ThunkActionVoid } from './thunkActions';

export const displaySynchronizationError = (): ThunkActionVoid => (dispatch, getState) => {
  const state = getState();

  if (
    hasAssemblyPermission(state) &&
    (state.application.openContext?.type === 'station' || state.application.openContext?.type === 'schedule-station')
  ) {
    dispatch(
      enqueuePermanentError('Unable to synchronize.  You will need to refresh the page to see station changes.'),
    );
    return;
  }
};

export const displayRemoteSynchronizationError = (): ThunkActionVoid => (dispatch, getState) => {
  const state = getState();

  if (hasAssemblyPermission(state) || shouldSynchronizeComponent(state)) {
    dispatch(
      enqueuePermanentError(
        'Failed to synchronize to other machines. Refresh the Design Program on other computers using this station.',
      ),
    );
    return;
  }
};

export const buildSynchronizationErrorRequestMiddleware = (reduxStore: typeof store): Middleware<unknown, unknown> =>
  buildMiddleware((data) => {
    if (
      data &&
      (Object.hasOwn(data, 'result') || Object.hasOwn(data, 'componentDesignWithTimestamps')) &&
      (data as SynchronizedResult<unknown> | UpdateResponse).successfullySynchronized === false
    ) {
      reduxStore.dispatch(displayRemoteSynchronizationError());
    }

    return data;
  });
